export interface ThreadMetadata {
  title?: string;
  inquiry_type?: string | null;
}

export const mergeThreadMetadata = <T extends ThreadMetadata>(
  previous: T,
  update: ThreadMetadata,
): T => ({
  ...previous,
  ...(update.title !== undefined ? { title: update.title } : {}),
  ...(update.inquiry_type !== undefined
    ? { inquiry_type: update.inquiry_type }
    : {}),
});

export const threadMetadataFromEvent = (data: any): ThreadMetadata => ({
  ...(data?.title !== undefined ? { title: data.title } : {}),
  ...(data?.inquiry_type !== undefined
    ? { inquiry_type: data.inquiry_type }
    : {}),
});
